import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import { useServices } from "@/services-context";
import { FORMATTER_LISTENER_NAME } from "@/services/formatter.ts";

export interface PriceValueProps {
  amount?: number;
  isVatApplicable?: boolean;
  divideCurrencySymbol?: boolean;
  isDisable?: boolean;
  className?: string;
}

const PriceValue: React.FC<PriceValueProps> = ({ className, amount = 0, isVatApplicable = false, divideCurrencySymbol = false, isDisable = false }) => {
  const { formatter } = useServices([FORMATTER_LISTENER_NAME]);

  const { currencySymbol, price } = formatter.getSeparateCurrencySymbolAndPrice(amount, "full", isVatApplicable);

  if (divideCurrencySymbol) {
    return (
      <div className={classNames(className, styles.root, styles["price-value-root"], { [styles.disabled]: isDisable })}>
        <div className={styles["currency-symbol"]}>{currencySymbol}</div>
        <div>{price}</div>
      </div>
    );
  }

  return (
    <span className={classNames(styles.root, { [styles.disabled]: isDisable })}>
      {currencySymbol} {price}
    </span>
  );
};

export default PriceValue;
